import { BaseStore } from 'fluxible/addons';
import Immutable from 'immutable';

export const CUSTOM_PACKAGE_TYPE = 'other';

class BriefPackageTypeStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.selectedPackageType = '';
        this.customPackageType = '';
        this.packageTypes = new Immutable.OrderedSet([]);
    }

    load(payload) {
        if (payload.package_types) {
            this.packageTypes = new Immutable.OrderedSet(payload.package_types);
        }

        if (payload.body.package_type) {
            if (payload.body.package_type === CUSTOM_PACKAGE_TYPE) {
                this.customPackageType = payload.body.custom_package_type;
            }

            this.selectedPackageType = payload.body.package_type;
        }

        this.emitChange();
    }

    selectPackageType(packageType) {
        if (this.selectedPackageType !== packageType) {
            this.selectedPackageType = packageType;
        }

        this.emitChange();
    }

    updateCustomPackageType(payload) {
        this.customPackageType = payload.value;
        this.emitChange();
    }

    isStepComplete() {
        if (this.selectedPackageType === CUSTOM_PACKAGE_TYPE) {
            return this.customPackageType && this.customPackageType.trim().length;
        } else {
            return this.selectedPackageType.length > 0;
        }
    }
}

BriefPackageTypeStore.storeName = 'BriefPackageTypeStore';
BriefPackageTypeStore.handlers = {
    SELECT_PACKAGE_TYPE: 'selectPackageType',
    UPDATE_CUSTOM_PACKAGE_TYPE: 'updateCustomPackageType',
    LOAD_DRAFT_DATA: 'load',
};

export default BriefPackageTypeStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefPackageTypeStore.js